export default "__VITE_ASSET__DTuXLvgu__"